import { DatePicker as AntDatePicker } from 'antd';
import moment from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

// Datepicker generated from moment. Ant5 moved to dayjs
const DatePicker = AntDatePicker.generatePicker<moment.Moment>(momentGenerateConfig);

export default DatePicker